export default {
  tourData: {
    fallback: {
      included: ['Passeio inclusivo', 'Atendimento local', 'Experiência exclusiva em Paraty'],
      notIncluded: ['Refeições e bebidas', 'Transfer de hotel'],
      bringItems: ['Protetor solar', 'Roupas leves', 'Água', 'Câmera'],
      meetingPoint: 'Paraty, RJ',
      startTime: 'A confirmar',
      maxGroupSize: 'Grupo',
      cancellation: 'Consulte a política de cancelamento do passeio.',
      privacyPolicy: 'Política de privacidade disponível no site.',
      importantNotes: ['Confirme o horário com a equipe antes do passeio.'],
      genericTag: 'Passeio de barco',
    },
  },
};
